import { Editor } from '@/common/components/Editor'
import {
	FormControl,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from '@/common/ui/form'
import { RequiredIndicator } from '@/common/ui/form/required-indicator'
import { Input } from '@/common/ui/input'
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '@/common/ui/select'
import { Switch } from '@/common/ui/switch'
import { Control } from 'react-hook-form'

interface BaseFieldProps {
	control: Control<any>
	label?: string
}

export function NameField({
	control,
	label = 'ตั้งชื่อโปรโมชั่น',
}: BaseFieldProps) {
	return (
		<FormField
			control={control}
			name="name"
			render={({ field }) => (
				<FormItem>
					<FormLabel>
						<RequiredIndicator />
						{label}
					</FormLabel>
					<FormControl>
						<Input {...field} placeholder={`กรอก${label}`} />
					</FormControl>
					<FormMessage />
				</FormItem>
			)}
		/>
	)
}

export function BannerField({
	control,
	label = 'รูปป้ายโปรโมชั่น',
}: BaseFieldProps) {
	return (
		<FormField
			control={control}
			name="banner"
			render={({ field }) => (
				<FormItem>
					<FormLabel>{label}</FormLabel>
					<FormControl>
						<Input {...field} placeholder={`กรอกลิงค์${label}`} />
					</FormControl>
					<FormMessage />
				</FormItem>
			)}
		/>
	)
}

export function TurnoverField({
	control,
	label = 'เทิร์นโอเวอร์ (จำนวนเท่าของยอด)',
}: BaseFieldProps) {
	return (
		<FormField
			control={control}
			name="turnoverRound"
			render={({ field }) => (
				<FormItem>
					<FormLabel>
						<RequiredIndicator />
						{label}
					</FormLabel>
					<FormControl>
						<Input
							type="number"
							placeholder="กรอกเทิร์นโอเวอร์ (จำนวนเท่าของยอด)"
							{...field}
							value={field.value ?? ''}
							onChange={(e) =>
								field.onChange(e.target.value ? Number(e.target.value) : null)
							}
						/>
					</FormControl>
					<FormMessage />
				</FormItem>
			)}
		/>
	)
}

export function IsActiveField({ control }: BaseFieldProps) {
	return (
		<FormField
			control={control}
			name="isActive"
			render={({ field }) => (
				<FormItem className="flex flex-col items-center gap-2">
					<FormLabel>เปิดใช้งาน</FormLabel>
					<FormControl>
						<Switch checked={field.value} onCheckedChange={field.onChange} />
					</FormControl>
				</FormItem>
			)}
		/>
	)
}

export function ShortDescriptionField({ control }: BaseFieldProps) {
	return (
		<FormField
			control={control}
			name="shortDescription"
			render={({ field }) => (
				<FormItem className="col-span-2">
					<FormLabel>คำอธิบาย</FormLabel>
					<FormControl>
						<Input {...field} placeholder="กรอกคำอธิบาย" />
					</FormControl>
					<FormMessage />
				</FormItem>
			)}
		/>
	)
}

export function DescriptionField({ control }: BaseFieldProps) {
	return (
		<FormField
			control={control}
			name="description"
			render={({ field }) => (
				<FormItem className="col-span-2">
					<FormLabel>คำอธิบายเพิ่มเติม</FormLabel>
					<FormControl>
						<Editor
							value={field.value || ''}
							onChange={field.onChange}
							placeholder="กรอกคำอธิบาย"
							className="min-h-[200px] [&_.ql-container]:!min-h-[150px]"
						/>
					</FormControl>
					<FormMessage />
				</FormItem>
			)}
		/>
	)
}

export function DurationDaysField({ control }: BaseFieldProps) {
	return (
		<FormField
			control={control}
			name="durationDays"
			render={({ field }) => (
				<FormItem>
					<FormLabel>ระยะเวลา (วัน)</FormLabel>
					<FormControl>
						<Input
							type="number"
							{...field}
							onChange={(e) => field.onChange(Number(e.target.value))}
						/>
					</FormControl>
					<FormMessage />
				</FormItem>
			)}
		/>
	)
}

export function SelectedLevelsField({ control }: BaseFieldProps) {
	return (
		<FormField
			control={control}
			name="selectedLevels"
			render={({ field }) => (
				<FormItem>
					<FormLabel>จำนวน Level</FormLabel>
					<Select
						onValueChange={(value) => field.onChange(Number(value))}
						defaultValue={String(field.value)}
					>
						<FormControl>
							<SelectTrigger>
								<SelectValue placeholder="เลือกจำนวน Level" />
							</SelectTrigger>
						</FormControl>
						<SelectContent>
							<SelectItem value="1">1 Level</SelectItem>
							<SelectItem value="2">2 Levels</SelectItem>
							<SelectItem value="3">3 Levels</SelectItem>
						</SelectContent>
					</Select>
					<FormMessage />
				</FormItem>
			)}
		/>
	)
}
